import { render, staticRenderFns } from "./VarsViewer.vue?vue&type=template&id=3879013a"
import script from "./VarsViewer.vue?vue&type=script&lang=js"
export * from "./VarsViewer.vue?vue&type=script&lang=js"
import style0 from "./VarsViewer.vue?vue&type=style&index=0&id=3879013a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports